import {useTranslation} from 'react-i18next';

export default function t(translate, data) {
    return useTranslation().t(translate, data);
};

